import { inject, Injectable } from '@angular/core';
import { CanDeactivate, Router, UrlTree } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { ForceLogoutComponent } from '../../layout/main/force-logout/force-logout.component';
import { AuthService } from '../auth/auth.service';
import { map, withLatestFrom } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CanForceLogoutGuard
  implements CanDeactivate<ForceLogoutComponent>
{
  _authService = inject(AuthService);
  _router = inject(Router);
  canDeactivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this._authService.canAccessAgency$.pipe(
      withLatestFrom(this._authService.urlToRedirect$),
      tap(([x, url]) => {
        if (!x) {
          this._router.navigateByUrl(url);
        }
      }),
      map(([x]) => x)
    );
  }
}
